import { render, staticRenderFns } from "./AppBottomSheet.vue?vue&type=template&id=2efbfaf3&scoped=true"
import script from "./AppBottomSheet.vue?vue&type=script&lang=js"
export * from "./AppBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./AppBottomSheet.vue?vue&type=style&index=0&id=2efbfaf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbfaf3",
  null
  
)

export default component.exports